import request from '@/utils/request'
// 查询随机好评语
export function randomGain(query) {
  return request({
    url: '/dev-api/system/service/randomGain',
    method: 'get',
    params: query
  })
}




// WEBPACK FOOTER //
// ./src/api/comment/comment.js